import styled from 'styled-components';

export namespace S {
	export const Container = styled.section`
		display: flex;
		flex: 1;
		justify-content: center;
		align-items: center;
	`;
	export const ContainerWrapper = styled.article`
		display: flex;
		flex: 1;
		justify-content: space-evenly;
		align-items: flex-start;
		max-width: 550px;
		padding: ${({ theme }) => `${theme.spacings.medium} ${theme.spacings.xlarge}`};
		${({ theme }) => theme.breakpoints.queries.below.tabletSmallDesktop} {
			padding: ${({ theme }) => theme.spacings.medium};
		}
	`;
	export const IconContainer = styled.div`
		display: flex;
		flex: 1;
		justify-content: center;
		align-items: center;
	`;
}
